import * as tslib_1 from "tslib";
import { Component, forwardRef } from '@angular/core';
import { LocalizationService } from '@progress/kendo-angular-l10n';
import { Messages } from './messages';
/**
 * Custom component messages override default component messages.
 */
var DatePickerCustomMessagesComponent = (function (_super) {
    tslib_1.__extends(DatePickerCustomMessagesComponent, _super);
    function DatePickerCustomMessagesComponent(service) {
        var _this = _super.call(this) || this;
        _this.service = service;
        return _this;
    }
    Object.defineProperty(DatePickerCustomMessagesComponent.prototype, "override", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    return DatePickerCustomMessagesComponent;
}(Messages));
export { DatePickerCustomMessagesComponent };
DatePickerCustomMessagesComponent.decorators = [
    { type: Component, args: [{
                providers: [
                    {
                        provide: Messages,
                        useExisting: forwardRef(function () { return DatePickerCustomMessagesComponent; }) // tslint:disable-line:no-forward-ref
                    }
                ],
                selector: 'kendo-datepicker-messages',
                template: ""
            },] },
];
/** @nocollapse */
DatePickerCustomMessagesComponent.ctorParameters = function () { return [
    { type: LocalizationService, },
]; };



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@progress/kendo-angular-dateinputs/dist/es/datepicker/localization/datepicker-custom-messages.component.js
// module id = ../../../../@progress/kendo-angular-dateinputs/dist/es/datepicker/localization/datepicker-custom-messages.component.js
// module chunks = 3